'use client'

import { useEffect, useRef } from 'react'
import Link from 'next/link'
import type { ServiceCardData } from './types'

export function ServiceListRow({
  service,
  selected,
  onSelect,
}: {
  service: ServiceCardData
  selected: boolean
  onSelect: (slug: string) => void
}) {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (selected) ref.current?.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
  }, [selected])

  return (
    <div
      ref={ref}
      className={`svc-list-row${selected ? ' svc-list-row--selected' : ''}`}
      onClick={() => onSelect(service.slug)}
      role="button"
      tabIndex={0}
      onKeyDown={e => { if (e.key === 'Enter') onSelect(service.slug) }}
    >
      <span className="svc-list-row-icon" style={{ background: service.categoryColor }}>
        {service.categoryIcon}
      </span>
      <div className="svc-list-row-info">
        <div className="svc-list-row-name">{service.name}</div>
        <div className="svc-list-row-meta">
          {service.categoryName}
          {(service.clusterName || service.address) && ` · ${service.clusterName ?? service.address}`}
        </div>
      </div>
      <Link
        href={`/services/${service.slug}`}
        className="svc-list-row-link"
        onClick={e => e.stopPropagation()}
      >
        View details →
      </Link>
    </div>
  )
}
